import { CanActivateFn } from '@angular/router';

export const roleGuard: CanActivateFn = (_route) => {
  // TODO: TEMPORAL - todas las rutas habilitadas, quitar antes de producción
  return true;
};
